//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import List from '@/components/table';
import messageBox from '@/components/messageBox';
import editAgentApp from './components/editAgentApp.vue';
import createAgentApp from './components/createAgentApp.vue';
import copyAgentApp from './components/copyAgentApp.vue';
import _ from 'lodash';

export default {
  components: {
    List,
    messageBox,
    editAgentApp,
    createAgentApp,
    copyAgentApp,
  },
  data() {
    return {
      // 加载状态
      loading: false,
      tabList: [
        { name: '1', label: '已启用' },
        { name: '2', label: '已停用' },
      ],
      // 搜索表单
      aiAgentForm: {
        name: '',
        type: '',
      },
      appList: [
        {
          label: '会话流',
          value: 'chatflow',
        },
        {
          label: '工作流',
          value: 'workflow',
        },
        {
          label: '营销工作流',
          value: 'ma',
        },
      ],
      layout: [
        { name: 'id', label: '唯一编码' },
        { name: 'name', label: '应用名称', lines: 3, minWidth: 120 },
        { name: 'type', label: '应用类型' },
        { name: 'description', label: '描述', lines: 3, minWidth: 150 },
        // { name: 'scheduler_type', label: '调度类型' },
        // { name: 'graph', label: '发布的流程配置' },
        // { name: 'graph_draft', label: '草稿流程配置' },
        { name: 'is_system', label: '是否系统应用' },
        { name: 'version', label: '版本号' },
        { name: 'enable', label: '是否生效' },
        { name: 'create_time', label: '创建时间' },
        { name: 'create_by', label: '创建人' },
        { name: 'update_time', label: '最后操作时间' },
        { name: 'update_by', label: '最后操作人' },
      ],
      createVisible: false,
      detailVisible: false,
      copyVisible: false,
      copyRow: {},
      rowMessage: {
        id: '',
        name: '',
        description: '',
        type: '',
        graph: '',
        graph_draft: '',
        is_system: true,
        version: '',
      },
      // // 新建窗口展示
      // basicInfoVisable: false,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      // this.getElementList
      console.log('%c Line:154 🍷 this.getElementList', 'color:#4fff4B', this.getElementList);
      const jurisdictionArray = [
        'aiAgentAppManagement_agent_edit',
        'aiAgentAppManagement_agent_release',
        'aiAgentAppManagement_agent_delete',
        'aiAgentAppManagement_agent_create',
        'aiAgentAppManagement_agent_copy',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      console.log('%c Line:167 🍷 jurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.loading = true;
  },
  methods: {
    refresh() {
      this.$refs.list.resetPage();
      this.$refs.list.getList();
    },

    // 获取列表数据
    getList({ pageIndex, pageSize }) {
      // pageIndex, pageSize
      console.log('%c Line:188 🍒 pageIndex, pageSize', 'color:#7f2b82', pageIndex, pageSize);
      const params = {
        offset: (pageIndex - 1) * pageSize,
        limit: pageSize,
      };
      if (this.aiAgentForm.name) {
        params.name = this.aiAgentForm.name;
      }
      if (this.aiAgentForm.type) {
        params.type = this.aiAgentForm.type;
      }
      return this.$request({
        url: this.$api.getAiListAgentApps,
        data: params,
      }).then((res) => {
        // res
        console.log('%c Line:162 🍎 res', 'color:#7f2b82', res);
        const list = res?.agent_apps || [];

        // const computedList = list.map((item) => ({
        //   ...item,
        //   is_system: item.is_system ? '是' : '否',
        // }));
        const computedList = list.map((item) => ({
          ...item,
          enable: item.enable ? '是' : '否',
          is_system: item.is_system ? '是' : '否',
          type: this.appList.find((app) => app.value === item.type)?.label || item.type,
        }));
        return {
          list: computedList,
          total: res?.total_count || 0,
        };
      });
    },

    // 表单查询
    handleInput: _.debounce(function () {
      this.refresh();
    }, 1000),

    handleReset() {
      this.aiAgentForm.name = '';
      this.aiAgentForm.type = '';
      this.refresh();
    },

    // 增删改
    add() {
      this.createVisible = true;
    },

    edit(row) {
      this.rowMessage = row;
      this.detailVisible = true;
    },
    toDetail(row) {
      this.$router.push({
        name: 'ai-app-detail',
        query: {
          id: row.id,
          name: row.name || '',
          description: row.description || '',
          enable: row.enable || '',
          create_time: row.create_time || '',
          update_time: row.update_time || '',
        },
      });
    },
    toFlow(row) {
      this.$router.push({
        name: 'ai-flow-nodes',
        query: {
          id: row.id,
        },
      });
    },

    publish({ id, version }) {
      this.$refs.messageBox.show({
        title: '提示',
        content: '确定发布该AgentApp吗?',
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.publishAgentApp,
            data: { id, version },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },

    copyApp(row) {
      // 需要还原type为原始值（列表中type被映射为label了）
      const typeMap = {};
      this.appList.forEach((item) => {
        typeMap[item.label] = item.value;
      });
      this.copyRow = {
        ...row,
        type: typeMap[row.type] || row.type,
      };
      this.copyVisible = true;
    },

    toDelete({ id }) {
      this.$refs.messageBox.show({
        title: '提示',
        content: '确定删除该数据吗?',
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.deleteAgentAppById,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },
  },
};
